export enum EButtonActions {
  UPLOAD = 'upload',
  WRITE = 'write',
  TEMPLATE = 'template'
}
